import PropTypes from 'prop-types';

export const TabsComponentTypes = {
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
    color: PropTypes.oneOf(['primary', 'secondary', 'success', 'error', 'warning', 'light']),
    customColor: PropTypes.string,
    tabs: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
      disabled: PropTypes.bool,
      icon: PropTypes.node,
      content: PropTypes.node,
      count: PropTypes.any
    })).isRequired,
    centered: PropTypes.bool,
    children: PropTypes.node,
    heightfull: PropTypes.bool,
  };